const firebaseConfig = {
  apiKey: "AIzaSyCxCA4-jRuVtAnUFV4yhusBX7pfpIq9Ono",
  authDomain: "healthcare-5c5c4.firebaseapp.com",
  projectId: "healthcare-5c5c4",
  storageBucket: "healthcare-5c5c4.appspot.com",
  messagingSenderId: "123520650990",
  appId: "1:123520650990:web:3c805be8f04d66c654adff",
  measurementId: "G-V9ZY194PD3"
};
  export default firebaseConfig;